exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mt-cell[data-v-0df1f6bb]{background:#fff;border-bottom:1px solid #f0f0f0;line-height:52px}.hospital-name[data-v-0df1f6bb]{padding-left:10px}.gray[data-v-0df1f6bb]{color:#cfcfcf}", "", {"version":3,"sources":["F:/1.前端/ykb-weixin/src/views/appointment/select-hospital.vue"],"names":[],"mappings":"AACA,0BACE,gBAAiB,AACjB,gCAAiC,AACjC,gBAAkB,CACnB,AACD,gCACE,iBAAmB,CACpB,AACD,uBACE,aAAe,CAChB","file":"select-hospital.vue","sourcesContent":["\n.mt-cell[data-v-0df1f6bb] {\n  background: #fff;\n  border-bottom: 1px solid #F0F0F0;\n  line-height: 52px;\n}\n.hospital-name[data-v-0df1f6bb]{\n  padding-left: 10px;\n}\n.gray[data-v-0df1f6bb] {\n  color: #cfcfcf;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-0df1f6bb","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/appointment/select-hospital.vue
// module id = 467
// module chunks = 18